import { isElementType } from '@lumapps/wrex/slate/utils/isElementType';

import { T_H } from '../constants';
import type { THElement } from '../types';

/** Whether a node is a table header cell (`th`). */
export const isTableHeaderCell = isElementType<THElement>(T_H);
